<template>
	<div style="width: 100%;height: 100vh;">

		<el-carousel :interval="3000" arrow="hover">
			<el-carousel-item v-for="(item,index) in carouselItems" :key="index">
				<div class="carousel-item">
					<img class="img" :src="item.picUrl" />
					<!-- <div class="text">
							{{item.description}}
						</div> -->
				</div>
			</el-carousel-item>
		</el-carousel>
		<div class="flex-row-center-center" style="width: 100%;">
			<div class="flex-row-center-center tz1">
				<div class="flex-column-center-center" style="border-left: 1px solid #eee;width: 25%;">
					<div class="flex-column-start-center" style="margin-left: 10px;">
						<div class="flex-row-start-start">
							<span class="t20BoldFont" style="color: #0052D9;">{{tjModel.serviceCustomers}}</span>
							<span class="t1Font">+</span>
						</div>
						<span class="t2Font" style="margin-top: 5px;">服务客户</span>
					</div>
				</div>
				<div class="flex-column-center-center"
					style="border-left: 1px solid #eee;width: 25%;border-right: 1px solid #eee;">
					<div class="flex-column-start-center" style="margin-left: 10px;">

						<div class="flex-row-start-start">
							<span class="t20BoldFont" style="color: #0052D9;">{{tjModel.talents}}</span>
							<span class="t1Font">+</span>
						</div>
						<span class="t2Font" style="margin-top: 5px;">人才库</span>
					</div>
				</div>
				<div class="flex-column-center-center" style="width: 25%;border-right: 1px solid #eee;">
					<div class="flex-column-start-center" style="margin-left: 10px;">

						<div class="flex-row-start-start">
							<span class="t20BoldFont" style="color: #0052D9;">{{tjModel.personnels}}</span>
							<span class="t1Font">+</span>
						</div>
						<span class="t2Font" style="margin-top: 5px;">共享人员</span>
					</div>
				</div>
				<div class="flex-column-center-center" style="border-right: 1px solid #eee;width: 25%;">
					<div class="flex-column-start-center" style="margin-left: 10px;">

						<div class="flex-row-start-start">
							<span class="t20BoldFont" style="color: #0052D9;">{{tjModel.jobs}}</span>
							<span class="t1Font">+</span>
						</div>
						<span class="t2Font" style="margin-top: 5px;">高薪职位</span>
					</div>
				</div>
			</div>
		</div>
		<div class="flex-row-center-center" style="width: 100%;">
			<div class="notice-box">

				<img src="../assets/m_note.png" class="icon" />

				<div class="title">智能匹配通知</div>

				<!-- 公告滚动区域 -->
				<div class="notice-marquee">
					<ul class="notice-list" :style="{ transform: `translateY(-${currentIndex * 60}px)` }">
						<li v-for="(item, index) in notes" :key="index">
							{{ item.title }}
						</li>
					</ul>
				</div>

			</div>
		</div>

		<div class="video-contain">
			<video ref="videoPlayer" :src="videoSrc" controls preload="metadata" @play="onPlay" @pause="onPause"
				@ended="onEnded">
				您的浏览器不支持 video 标签
			</video>
		</div>

		<!-- 新闻部分 -->
		<div class="flex-row-center-center t20BoldFont yhzx">
			<span>政务资讯</span>
		</div>
		<!-- <div class="flex-row-center-center zx">
			<span>提供全面、精准、专业的行业资讯</span>
		</div> -->
		<div class="flex-row-center-center" style="width: 100%;">
			<div class="zx-contain">
				<el-card v-for="(item,index) in zxListType0" :key="index" class="uniform-card">
					<div class="card-title two-line-text">{{item.title}}</div>
					<div class="img-wrapper">
						<img :src="item.picUrl || defaultImage">
					</div>
					<div class="card-content two-line-text1">{{item.intro}}</div>
					<div class="card-actions flex-row-spacebetween-center">
						<span>了解详情</span>
						<img class="rightimage clickable" :src="rightImage" @click="bindClick(item)" />
					</div>
				</el-card>
			</div>
		</div>


		<div class="flex-row-center-center t20BoldFont yhzx">
			<span>航空文化</span>
		</div>
		<!-- <div class="flex-row-center-center zx">
			<span>提供全面、精准、专业的行业资讯</span>
		</div> -->
		<div class="flex-row-center-center" style="width: 100%;">
			<div class="zx-contain">
				<el-card v-for="(item,index) in zxListType1" :key="index" class="uniform-card">
					<div class="card-title two-line-text">{{item.title}}</div>
					<div class="img-wrapper">
						<img :src="item.picUrl || defaultImage">
					</div>
					<div class="card-content two-line-text1">{{item.intro}}</div>
					<div class="card-actions flex-row-spacebetween-center">
						<span>了解详情</span>
						<img class="rightimage clickable" :src="rightImage" @click="bindClick(item)" />
					</div>
				</el-card>
			</div>
		</div>


		<div class="flex-row-center-center t20BoldFont yhzx">
			<span>科研机构</span>
		</div>
		<!-- <div class="flex-row-center-center zx">
			<span>提供全面、精准、专业的行业资讯</span>
		</div> -->
		<div class="flex-row-center-center" style="width: 100%;">
			<div class="zx-contain">
				<el-card v-for="(item,index) in zxListType2" :key="index" class="uniform-card">
					<div class="card-title two-line-text">{{item.title}}</div>
					<div class="img-wrapper">
						<img :src="item.picUrl || defaultImage">
					</div>
					<div class="card-content two-line-text1">{{item.intro}}</div>
					<div class="card-actions flex-row-spacebetween-center">
						<span>了解详情</span>
						<img class="rightimage clickable" :src="rightImage" @click="bindClick(item)" />
					</div>
				</el-card>
			</div>
		</div>


		<div class="flex-row-center-center t20BoldFont yhzx">
			<span>合作院校</span>
		</div>
		<!-- <div class="flex-row-center-center zx">
			<span>提供全面、精准、专业的行业资讯</span>
		</div> -->
		<div class="flex-row-center-center" style="width: 100%;">
			<div class="zx-contain">
				<el-card v-for="(item,index) in zxListType3" :key="index" class="uniform-card">
					<div class="card-title two-line-text">{{item.title}}</div>
					<div class="img-wrapper">
						<img :src="item.picUrl || defaultImage">
					</div>
					<div class="card-content two-line-text1">{{item.intro}}</div>
					<div class="card-actions flex-row-spacebetween-center">
						<span>了解详情</span>
						<img class="rightimage clickable" :src="rightImage" @click="bindClick(item)" />
					</div>
				</el-card>
			</div>
		</div>


		<div class="flex-row-center-center t20BoldFont yhzx">
			<span>园区企业</span>
		</div>
		<!-- <div class="flex-row-center-center zx">
			<span>提供全面、精准、专业的行业资讯</span>
		</div> -->
		<div class="flex-row-center-center" style="width: 100%;">
			<div class="zx-contain">
				<el-card v-for="(item,index) in zxListType4" :key="index" class="uniform-card">
					<div class="card-title two-line-text">{{item.title}}</div>
					<div class="img-wrapper">
						<img :src="item.picUrl || defaultImage">
					</div>
					<div class="card-content two-line-text1">{{item.intro}}</div>
					<div class="card-actions flex-row-spacebetween-center">
						<span>了解详情</span>
						<img class="rightimage clickable" :src="rightImage" @click="bindClick(item)" />
					</div>
				</el-card>
			</div>
		</div>

		<div class="flex-row-center-center t20BoldFont yhzx">
			<span>核心业务模块</span>
		</div>
		<!-- 岗位部分 -->
		<div class="flex-row-center-center" style="width: 100%;">
			<div class="rc-contain background-section">
				<div v-for="(item,index) in gwList" :key="index" class="uniform-card5">
					<div class="flex-row-center-center" style="margin-top: 30px;">
						<img :src="item.img || defaultImage" :alt="item.title" style="width: 60px;height: 60px;">
					</div>
					<div class="flex-row-center-center" style="margin-top: 20px;">
						<div class="card-title two-line-text whiteColor">{{item.title}}</div>
					</div>
					<div class="flex-row-center-center" style="margin-top: 10px;">
						<div class="card-content two-line-text1" style="text-align: center;color: black;">
							{{item.content}}
						</div>
					</div>
					<div class="flex-row-center-center" style="width: 100%;">
						<div class="flex-row-center-center clickable" @click="handleJob(index)"
							style="border: 1px solid #0052D9;width: 100px;padding: 5px;border-radius: 25px;color: #0052D9;margin-top: 10px;">
							{{item.btitle}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 人才部分 -->
		<div class="flex-row-center-center" style="width: 100%;">
			<div class="rc-contain background-section-rencai">
				<div v-for="(item,index) in rcList" :key="index" class="uniform-card5">
					<div class="flex-row-center-center" style="margin-top: 30px;">
						<img :src="item.img || defaultImage" :alt="item.title" style="width: 60px;height: 60px;">
					</div>
					<div class="flex-row-center-center" style="margin-top: 20px;">
						<div class="card-title two-line-text whiteColor">{{item.title}}</div>
					</div>
					<div class="flex-row-center-center" style="margin-top: 10px;">
						<div class="card-content two-line-text1" style="text-align: center;color: black;">
							{{item.content}}
						</div>
					</div>
					<div class="flex-row-center-center" style="width: 100%;">
						<div class="flex-row-center-center clickable" @click="handlePersonnel(index)"
							style="border: 1px solid #0052D9;width: 100px;padding: 5px;border-radius: 25px;color: #0052D9;margin-top: 10px;">
							{{item.btitle}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 平台简介部分 -->
		<div class="flex-column-start-center background-pt" style="margin: 50px 0; width: 100%;">
			<div class="flex-row-center-center about-us-wrapper">
				<div class="about-us-content">

					<div class="grid-content">
						<span class="t20BoldFont">平台简介</span>
						<span
							style="line-height: 2em;font-size: 14px;">景德镇高新开发区航空人才共享网，是景德镇高新开发区人社局为区内企业，特别是以以航空航天、高端装备为代表的特色产业相关企业打造的人才共享平台，本着为高效推进"景德镇航空人才共享中心"建设与运营，构建涵盖人才数据库，智能匹配，服务跟踪与信用评价等核心功能的共享生态，并由专业化运营团队提供平台维护，资源对接，活动组织及持续推广等服务，确保中心长效活跃与价值释放，为区内企业提供长久、持续、有效的服务。</span>
						<!-- <div class="flex-row-center-center"
							style="border: 1px solid #de8b4b;width: 100px;padding: 5px;border-radius: 20px;margin-top: 20px;">
							<span class="orgTextColor">了解更多</span>
						</div> -->
					</div>
					<img :src="usImgea" class="about-us-image" />
				</div>
			</div>
		</div>

		<!-- 友情链接 -->
		<div class="flex-row-center-center" style="width: 100%;">
			<div class="category-contain">
				<div class="category-indicater"></div>
				<span>战略合作伙伴 / 品牌链接</span>
			</div>
		</div>
		<div class="flex-row-center-center " style="width: 100%;">
			<div class="link-contain">
				<div v-for="(item,index) in friendLinks" :key="index" class="link-item clickable" @click="handleFriendLink(item)">
					<img :src="item.logoUrl" class="link-logo" />
					<span class="link-name">{{ item.name }}</span>
				</div>
			</div>
		</div>

		<div class="flex-row-center-start bck">
			<!-- <div class="flex-column-start-start" style="margin-right: 80px;">
					<span class="whiteColor t1Font">产品与服务</span>
					<span class="whiteColor t1Font" style="margin-top: 10px;">数字技术与人才外包(DTO)</span>
					<span class="whiteColor t1Font" style="margin-top: 10px;">数字化运营与业务外包(DBPO)</span>
					<span class="whiteColor t1Font" style="margin-top: 10px;">人力资源服务外包 (HRO)</span>
					<span class="whiteColor t1Font" style="margin-top: 10px;">招聘流程外包 (RPO)</span>
					<span class="whiteColor t1Font" style="margin-top: 10px;">海外人力资源服务(GHR)</span>
				</div>
				<div class="flex-column-start-start" style="margin-right: 80px;">
					<span class="whiteColor t1Font">关于人瑞</span>
					<span class="whiteColor t1Font" style="margin-top: 10px;">公司概况</span>
					<span class="whiteColor t1Font" style="margin-top: 10px;">投资者关系</span>
					<span class="whiteColor t1Font" style="margin-top: 10px;">奋斗者文化</span>
					<span class="whiteColor t1Font" style="margin-top: 10px;">内部招聘</span>
					<span class="whiteColor t1Font" style="margin-top: 10px;">联系我们</span>
				</div>
				<div class="flex-column-start-start" style="width: 200px;border-right: 1px solid #454545;">
					<span class="whiteColor t1Font">技术驱动</span>
					<span class="whiteColor t1Font" style="margin-top: 10px;">企业案例</span>
					<span class="whiteColor t1Font" style="margin-top: 10px;">行业洞察</span>
					<span class="whiteColor t1Font" style="margin-top: 10px;">人瑞动态</span>
					<span class="whiteColor t1Font" style="margin-top: 10px;">人瑞国际</span>
				</div>
				<div class="flex-column-start-start" style="width: 200px;padding-left: 100px;">
					<span class="whiteColor t1Font">XXXXXX</span>
					<span class="whiteColor t1Font" style="margin-top: 10px;">400-175-0886</span>
					<span class="whiteColor t1Font" style="margin-top: 10px;">BMD@renruihr.com</span>
				</div> -->
			<span class="whiteColor t1Font">京公网安备 11000002000001号</span>
			<span class="whiteColor t1Font" style="margin-left: 10px;">京ICP证030173号</span>
		</div>
	</div>
</template>

<script>
	import {
		getStoreList,
		getcarousellist,
		getapinewslist,
		getFriendlyLinklistAll,
		getsharingMatchResultList
	} from '../api/manageMent.js'
	import {
		gethomeStatistics
	} from '../api/dicModel.js'
	import dishesBanner from '../components/dishesBanner.vue'
	import bottomView from '../components/bottomView.vue'
	import seamlessScroll from '../components/seamlessScroll.vue'
	export default {
		components: {
			bottomView,
			dishesBanner,
			seamlessScroll
		},
		data() {
			return {
				videoSrc: require('@/assets/videos/index.mp4'), //视频地址
				activeIndex: '/JobDetail',
				Login: 1,
				defaultImage: require('@/assets/bg.png'),
				jumpImage: require('@/assets/right_you.png'),
				rightImage: require('@/assets/jump_org.png'),
				usImgea: require('@/assets/jianjie.jpg'),
				rcList: [{
						id: 1,
						title: "人才仓库",
						img: require('@/assets/m_rcck.png'),
						content: "海量航空人才库，覆盖从蓝领技工到国家级领军人才的全梯队。",
						btitle: '检索人才'
					},
					{
						id: 2,
						title: "技工分享",
						img: require('@/assets/m_jgfx.png'),
						content: "专注于高技能工匠的跨企业分享，解决生产季节性缺口难题。",
						btitle: '检索人才'
					},
					{
						id: 3,
						title: "储备人才",
						img: require('@/assets/m_cbrc.png'),
						content: "建立人才蓄水池，为高新产业提供持续不断的创新动能。",
						btitle: '储备库'
					},
				],
				gwList: [{
						id: 1,
						title: "岗位仓库",
						img: require('@/assets/m_gwck.png'),
						content: "汇聚全区航空制造、测绘、研发岗位，实时精准匹配人才画像。",
						btitle: '进入仓库'
					},
					{
						id: 2,
						title: "需求分享",
						img: require('@/assets/m_xqfx.png'),
						content: "打破企业信息孤岛，实现人力资源在行业内的灵活调配与共享。",
						btitle: '分享需求'
					},
					{
						id: 3,
						title: "储备岗位",
						img: require('@/assets/m_cbgw.png'),
						content: "针对企业中长期战略，提前锁定并储备高端技术与管理岗位。",
						btitle: '查看储备'
					},
				],
				zxListType0: [
					// {
					// 	id: 1,
					// 	title: "为什么HR都想转型做HRBP",
					// 	img: require('@/assets/zx1.png'),
					// 	content: "从HR转型做HRBP，价值何在?工作几年后，HR转型成为HRBP在人力资源行业里似乎已形成一种共识，90%..."
					// },
					// {
					// 	id: 2,
					// 	title: "@所有企业!社保降费力度再升级，费率减半…所有企业!社保降费力度再升级，费率减半所有企业!社保降费力度再升级，费率减半所有企业!社保降费力度再升级，费率减半",
					// 	img: require('@/assets/zx2.png'),
					// 	content: "上半年国家才发布了《关于延续实施部分减负稳岗扩就业政策措施的通知》。为了响应国家号召，各地政府一..."
					// },
					// {
					// 	id: 3,
					// 	title: "企业战略并不能帮助公司摆脱失败的命运",
					// 	img: require('@/assets/zx3.png'),
					// 	content: "产业发展到一定阶段出现饱和，竞争进入白热化阶段，企业就需要思考下一步如何做，这时就需要战略思维指导..."
					// },
				],
				zxListType1: [],
				zxListType2: [],
				zxListType3: [],
				zxListType4: [],
				pageWidth: window.innerWidth,
				pageHeight: window.innerHeight,

				imgStyle: {
					transform: 'rotate(0deg)', // 初始旋转设置为0度
				},
				startX: 0,
				startY: 0,
				// 第一组轮播数据
				carouselItems: [
					// {
					// 	id: 1,
					// 	src: require('@/assets/banner1.jpg'),
					// 	title: '图片一',
					// 	description: '这是第一张图片的描述'
					// },
					// {
					// 	id: 2,
					// 	src: require('@/assets/banner2.jpg'),
					// 	title: '图片二',
					// 	description: '这是第二张图片的描述'
					// },
					// {
					// 	id: 3,
					// 	src: require('@/assets/banner3.jpg'),
					// 	title: '图片三',
					// 	description: '这是第三张图片的描述'
					// }
				],
				queryParams: {
					type: 0
				},
				tjModel: {
					jobs: 0,
					personnels: 0,
					serviceCustomers: 0,
					talents: 0
				},
				friendLinks: [], //友情链接
				notes: [],
				currentIndex: 0,
				timer: null
			};
		},
		watch: {
			// 监听路由变化，更新激活菜单
			'$route.path': {
				immediate: true,
				handler(newPath) {
					this.activeIndex = newPath
				}
			}
		},
		created() {
			console.log("进入home页面");
			this.getHomedata()
			this.getBannerList()
			this.getNewsList()
			this.getFriendlinkAll()
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.handleResize);
		},
		methods: {
			getHomedata() {
				gethomeStatistics().then((res) => {
					console.log('统计接口=', res);
					this.tjModel = res.data
				});
			},
			getBannerList() {
				let param = {
					type: 0
				}
				getcarousellist(param).then((res) => {
					console.log(res);
					this.carouselItems = res.rows
				});

				let params = {
					pageNum: 1,
					pageSize: 9999
				}
				getsharingMatchResultList(params).then((res) => {
					console.log(res);
					this.notes = res.rows
					this.startScroll()
				});
			},
			startScroll() {
				this.timer = setInterval(() => {
					this.currentIndex++
					if (this.currentIndex >= this.notes.length) {
						this.currentIndex = 0
					}
				}, 3000) // 每 3 秒滚动一次
			},
			getNewsList() {
				let param = {
					type: 0,
					pageNum: 1,
					pageSize: 4
				}
				getapinewslist(param).then((res) => {
					console.log(res);
					this.zxListType0 = res.rows
				});
				let param1 = {
					type: 1,
					pageNum: 1,
					pageSize: 4
				}
				getapinewslist(param1).then((res) => {
					console.log(res);
					this.zxListType1 = res.rows
				});
				let param2 = {
					type: 2,
					pageNum: 1,
					pageSize: 4
				}
				getapinewslist(param2).then((res) => {
					console.log(res);
					this.zxListType2 = res.rows
				});
				let param3 = {
					type: 3,
					pageNum: 1,
					pageSize: 4
				}
				getapinewslist(param3).then((res) => {
					console.log(res);
					this.zxListType3 = res.rows
				});
				let param4 = {
					type: 4,
					pageNum: 1,
					pageSize: 4
				}
				getapinewslist(param4).then((res) => {
					console.log(res);
					this.zxListType4 = res.rows
				});
			},
			getFriendlinkAll() {
				let param = {
					pageNum: 1,
					pageSize: 10
				}
				getFriendlyLinklistAll(param).then((res) => {
					console.log(res);
					this.friendLinks = res.data
				});
			},
			handleSelect(key, keyPath) {
				console.log(key, keyPath);
				if (key == 1) {
					console.log("tiaozhuan");
					this.$router.push("/PolicyNewsDetail");
				}
			},
			handleFriendLink(item) {
				if (item.url) {
					window.open(item.url, '_blank');
				}
			},
			handleOpen(key, keyPath) {
				console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				console.log(key, keyPath);
			},
			bindClick(item) {
				console.log(item);
				this.$router.push("/PolicyNewsDetail?id=" + item.id);
			},
			handleResize() {
				this.pageWidth = window.innerWidth;
			},
			handleMouseMove(event) {
				const rect = event.target.getBoundingClientRect();
				const centerX = rect.left + rect.width / 2;
				const centerY = rect.top + rect.height / 2;

				// 计算鼠标相对于容器中心的角度
				const dx = event.clientX - centerX;
				const dy = event.clientY - centerY;
				const angle = Math.atan2(dy, dx) * 180 / Math.PI;

				// 设置图片的旋转样式
				this.imgStyle.transform = `rotate(${angle}deg)`;
			},
			resetRotation() {
				this.imgStyle.transform = 'rotate(0deg)'; // 鼠标离开时重置旋转
			},
			onPlay() {
				console.log('视频开始播放')
			},
			onPause() {
				console.log('视频暂停')
			},
			onEnded() {
				console.log('视频播放结束')
			},
			handleJob(index) {
				this.$router.push("/ngwxq?type=" + index);
			},
			handlePersonnel(index) {
				this.$router.push("/nrcxq?type=" + index);
			},
		}

	};
</script>

<style scoped>
	.notice-box {
		display: flex;
		align-items: center;
		width: 1200px;
		height: 60px;
		margin-top: 120px;
		background: #F8F9FB;
		border-radius: 12px;
	}

	/* 图标 */
	.icon {
		width: 20px;
		height: 20px;
		margin-left: 20px;
		flex-shrink: 0;
	}

	/* 标题 */
	.title {
		color: #0052D9;
		margin-left: 10px;
		flex-shrink: 0;
		white-space: nowrap;
	}

	/* 🔥 公告容器 */
	.notice-marquee {
		position: relative;
		height: 60px;
		overflow: hidden;
		flex: 1;
		margin-left: 20px;
	}

	/* 列表整体 */
	.notice-list {
		transition: transform 0.5s ease;
	}

	/* 单条公告 */
	.notice-list li {
		height: 60px;
		line-height: 60px;
		white-space: nowrap;
		color: #606266;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.background-section-rencai {
		margin-top: 30px;
		width: 1200px;
		/* background-image: url('~@/assets/background.png'); */
		background-color: #F2F7FF;
		/* 或使用你的背景图片 */
		background-size: cover;
		/* 背景图覆盖整个区域 */
		background-position: center;
		/* 背景图居中 */
		background-repeat: no-repeat;
		/* 不重复 */
		/* background-attachment: fixed; */
		/* padding: 40px 0; */
		/* 增加内边距，让内容不贴边 */
		position: relative;
		/* 为可能的遮罩层做准备 */
		/* margin-top: 30px; */
		background-color: #FFF9F5;
		/* padding: 10px 80px; */
		box-sizing: border-box;
		border-radius: 16px;
		gap: 16px;
	}

	.tz1 {
		width: 1200px;
		height: 192px;
		position: absolute;
		z-index: 10;
		border-radius: 20px;
		background-color: #fff;
		box-shadow: 0 30px 60px 0 #0000001f;
	}

	/deep/ .el-carousel__container {
		height: 500px !important;
	}

	.el-menu-vertical-demo {
		width: 180px;
		height: 100%;
	}

	.bck {
		background-color: #313131;
		/* height: 220px; */
		padding: 30px 20px;
		box-sizing: border-box;
		align-items: stretch;
	}

	.background-pt {
		margin-top: 30px;
		/* background-image: url('~@/assets/bg_pt.png'); */
		/* 或使用你的背景图片 */
		background-size: cover;
		/* 背景图覆盖整个区域 */
		background-position: center;
		/* 背景图居中 */
		background-repeat: no-repeat;
		/* 不重复 */
		/* background-attachment: fixed; */
		padding: 40px 0;
		/* 增加内边距，让内容不贴边 */
		position: relative;
		/* 为可能的遮罩层做准备 */
		background-color: #F9FAFB;
	}

	.rc-contain {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
	}

	.category-indicater {
		width: 4px;
		height: 16px;
		border-radius: 2px;
		background-color: #3964fe;
		margin-right: 10px;
	}

	.category-contain {
		display: flex;
		align-items: center;
		font-size: 20px;
		color: #000000;
		font-weight: bold;
		/* margin-left: 16%;
		margin-right: 16%; */
		width: 1200px;
	}

	.gw-contain {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
	}


	.background-section {
		margin-top: 30px;
		width: 1200px;
		/* background-image: url('~@/assets/background.png'); */
		background-color: #F2F7FF;
		/* 或使用你的背景图片 */
		background-size: cover;
		/* 背景图覆盖整个区域 */
		background-position: center;
		/* 背景图居中 */
		background-repeat: no-repeat;
		/* 不重复 */
		/* background-attachment: fixed; */
		/* padding: 40px 0; */
		/* 增加内边距，让内容不贴边 */
		position: relative;
		/* 为可能的遮罩层做准备 */
		/* margin-top: 30px; */
		background-color: #F2F7FF;
		/* padding: 10px 80px; */
		box-sizing: border-box;
		border-radius: 16px;
		gap: 16px;
	}

	.about-us-wrapper {
		width: 100%;
		/* padding: 0 10px; */
		/* 与政策资讯的卡片容器相同的左右padding */
		box-sizing: border-box;
	}

	.about-us-content {
		width: 65%;
		/* max-width: calc(30% * 3 + 20px * 2); */
		/* 3个卡片的宽度 + 2个margin */
		/* margin: 0 auto; */
		/* 居中对齐 */
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;

		background-color: #f6f6f6;
		align-items: stretch;
	}

	.grid-content {
		background-color: #fafafa;
		padding: 20px;
		display: flex;
		flex-direction: column;
		width: 50%;
		box-sizing: border-box;
	}

	/* 政策资讯卡片的容器样式 */
	.uniform-card-container {
		width: 100%;
		padding: 0 10px;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		margin-top: 20px;
	}

	.about-us-grid {
		display: grid;
		grid-template-columns: 55% 45%;
		grid-gap: 0;
		align-items: stretch;
		/* 关键：让两列高度相同 */
	}

	.grid-image {
		width: 100%;
		height: 100%;
		/* 关键：填满网格单元格 */
		object-fit: cover;
	}

	.grid-content {
		padding: 20px;
		display: flex;
		flex-direction: column;
	}

	.contact-info {
		margin-top: auto;
	}

	.rencai-container {
		width: 100%;
	}

	.rightimage {
		width: 30px;
		height: 30px;
		object-fit: cover;
	}

	.recai-container {
		padding: 30px 600px 20px 50px;

	}

	.rencai-card {
		height: 150px;
		margin: 10px;
	}

	/* 最后一个卡片去掉右边框 */
	/* .uniform-card1:last-child {
		border-right: none;
	} */

	.uniform-card1 {
		/* border-right: 1px solid #d6d6d6; */
		height: 330px;
		display: flex;
		width: 23%;
		/* 30% 宽度 */
		margin: 10px;
		/* 左右各 10px 边距 */
		flex-direction: column;
		box-sizing: border-box;
		/* 确保宽度计算包含 padding 和 border */
		margin-top: 40px;
		margin-bottom: 20px;
	}

	.uniform-card5 {
		/* border-right: 1px solid #d6d6d6; */
		height: 330px;
		display: flex;
		width: 23%;
		/* 30% 宽度 */
		margin: 10px;
		/* 左右各 10px 边距 */
		flex-direction: column;
		box-sizing: border-box;
		/* background-color: #d7e6fd; */
		opacity: 0.7;
	}

	/* 添加关于我们的容器样式 */
	.about-us-container {
		display: flex;
		/* justify-content: center; */
		width: 100%;
		padding: 0 10px;
		/* 与卡片相同的左右边距 */
		box-sizing: border-box;
		margin-top: 10px;
		margin-bottom: 30px;
	}

	/* 图片样式 - 计算精确宽度 */
	.about-us-image {
		width: 50%;
		/* 3个卡片宽度 + 2个间距 */
		height: 350px;
		object-fit: cover;
		box-sizing: border-box;
		border-radius: 16px;
	}

	.uniform-card {
		height: 400px;
		display: flex;
		width: 25%;
		gap: 16px;
		margin: 10px;
		flex-direction: column;
	}

	.card-title {
		height: 48px;
		font-size: 16px;
		font-weight: bold;
		color: #333;
		margin-bottom: 12px;
	}

	.img-wrapper {
		height: 180px;
		overflow: hidden;
		border-radius: 4px;
		margin-bottom: 12px;
	}

	.img-wrapper img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		transition: transform 0.3s;
	}

	.img-wrapper img:hover {
		transform: scale(1.05);
	}

	.card-content {
		flex: 1;
		height: 38px;
		color: #666;
		font-size: 16px;
		line-height: 1.5;
	}

	.card-actions {
		margin-top: 20px;
		padding-top: 12px;
		border-top: 1px solid #eee;
	}

	.two-line-text {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		line-height: 1.5em;
		/* 使用具体单位 */
		max-height: 50px;
		/* 2行 * 1.5行高 = 3em */
		word-break: break-word;
		/* 长单词换行 */
	}

	.two-line-text1 {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		line-height: 1.5em;
		/* 使用具体单位 */
		max-height: 50px;
		/* 2行 * 1.5行高 = 3em */
		word-break: break-word;
		font-size: 12px;
		/* 长单词换行 */
	}

	.zx {
		margin-top: 10px;
	}

	.yhzx {
		margin-top: 50px;
	}

	.carousel-item {
		position: relative;
		/* 关键 */
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.text {
		position: absolute;
		color: #fff;
		font-size: 24px;
		font-weight: bold;
		z-index: 2;
	}

	::v-deep .el-carousel__button {
		width: 10px;
		height: 10px;
		border-radius: 50%;
	}

	.conView {
		position: fixed;
		width: 100%;
		left: 0;
		top: 0;
		z-index: -1;
	}

	.banner {
		padding: 10px;
		width: 100%;
		height: 500px;
		box-sizing: border-box;
	}

	.image-container {
		overflow: hidden;
		position: relative;
		width: 300px;
		/* Adjust width and height as needed */
		height: 300px;
	}

	.guoClass {
		width: 275px;
		height: 275px;
	}

	.image-container img {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 100%;
		/* Adjust width as needed */
		height: auto;
		/* Maintain aspect ratio */
		cursor: pointer;
		transition: transform 0.1s ease-in-out;
		/* Smooth rotation */
	}

	.bgcolor {
		background-color: #272727;
	}

	.bgimg {
		background-image: url('~@/assets/bg.png');
		background-size: cover;
		/* 背景图片铺满元素 */
		background-position: center;
		/* 背景图片居中显示 */
		background-repeat: no-repeat;
		/* 背景图片不重复 */
	}

	.bounceleft {
		animation-name: moveleft;
		animation-duration: 0.6s;
		animation-timing-function: ease-in-out;
		animation-iteration-count: 1;
		animation-delay: 0s;
	}

	@keyframes moveleft {
		from {
			transform: translateX(-100%);
		}

		to {
			transform: translateX(0);
		}
	}

	.movedownToup {
		animation-name: moveup;
		animation-duration: 0.6s;
		animation-timing-function: ease-in-out;
		animation-iteration-count: 1;
		animation-delay: 0s;
	}

	.bounce {
		animation-name: moveup, bounce;
		animation-duration: 0.6s, 3s;
		animation-timing-function: ease-in-out, ease-in-out;
		animation-iteration-count: 1, infinite;
		animation-delay: 0s, 1s;
	}

	@keyframes moveup {
		from {
			transform: translateY(300px);
			opacity: 0;
		}

		to {
			transform: translateY(0px);
			opacity: 1;
		}
	}

	@keyframes bounce {

		0%,
		100% {
			transform: translateY(0px);
		}

		50% {
			transform: translateY(100px);
		}
	}

	.slide-out-down {
		animation: slideOutDown 2s ease forwards;
	}

	@keyframes slideOutDown {
		from {
			transform: translateY(-100%);
			opacity: 0;
		}

		to {
			transform: translateY(0px);
			opacity: 1;
		}
	}

	.testright {
		animation: slideOutRight 2s ease forwards;
	}

	@keyframes slideOutRight {
		from {
			transform: translateX(100%);
			opacity: 0;
		}

		to {
			transform: translateX(0px);
			opacity: 1;
		}
	}



	::-webkit-scrollbar {
		width: 0 !important;
	}

	::-webkit-scrollbar {
		width: 0 !important;
		height: 0;
	}

	/* 新闻资讯 */
	.zx-contain {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		width: 1200px;
		box-sizing: border-box;
	}

	.video-contain {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		margin-top: 10px;
	}

	.video-contain video {
		width: 50%;
	}

	.link-contain {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		align-items: center;
		border-radius: 10px;

		/* margin-left: 16%;
		margin-right: 16%; */
		width: 1200px;

		margin-top: 20px;
		margin-bottom: 20px;
		background-color: #f6f6f6;

		.link-item {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			padding: 20px 30px;

			.link-logo {
				width: 60px;
				height: 60px;
			}

			.link-name {
				font-size: 16px;
				color: #000;
				margin-top: 5px;
			}
		}
	}


	/* H5 */
	@media (max-width: 768px) {
		.notice-box {
			display: flex;
			align-items: center;
			width: 90%;
			height: 60px;
			margin-top: 60px;
			background: #F8F9FB;
			border-radius: 12px;
		}

		.tz1 {
			width: 95%;
			height: 100px;
			position: absolute;
			z-index: 10;
			border-radius: 20px;
			background-color: #fff;
			box-shadow: 0 30px 60px 0 #0000001f;
		}

		/deep/ .el-carousel__container {
			height: 200px !important;
		}

		/* 新闻资讯 */
		.zx-contain {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			padding: 0 20px;
			box-sizing: border-box;
		}

		.uniform-card {
			height: 400px;
			display: flex;
			width: 100%;
			margin: 10px;
			flex-direction: column;
		}

		.background-section {
			margin-top: 30px;
			/* background-image: url('~@/assets/background.png'); */
			/* 或使用你的背景图片 */
			background-size: cover;
			/* 背景图覆盖整个区域 */
			background-position: center;
			/* 背景图居中 */
			background-repeat: no-repeat;
			/* 不重复 */
			/* background-attachment: fixed; */
			padding: 40px 0;
			/* 增加内边距，让内容不贴边 */
			position: relative;
			/* 为可能的遮罩层做准备 */
			margin-top: 30px;
			background-color: #F2F7FF;
			padding: 10px 20px;
			box-sizing: border-box;
		}

		.background-section-rencai {
			margin-top: 30px;
			/* background-image: url('~@/assets/background.png'); */
			/* 或使用你的背景图片 */
			background-size: cover;
			/* 背景图覆盖整个区域 */
			background-position: center;
			/* 背景图居中 */
			background-repeat: no-repeat;
			/* 不重复 */
			/* background-attachment: fixed; */
			/* padding: 40px 0; */
			/* 增加内边距，让内容不贴边 */
			position: relative;
			/* 为可能的遮罩层做准备 */
			/* margin-top: 30px; */
			background-color: #FFF9F5;
			/* padding: 10px 80px; */
			box-sizing: border-box;
			border-radius: 16px;
			gap: 16px;
		}

		.rc-contain {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}

		.uniform-card5 {
			/* border-right: 1px solid #d6d6d6; */
			height: 330px;
			display: flex;
			width: 100%;
			/* 30% 宽度 */
			margin: 10px;
			/* 左右各 10px 边距 */
			flex-direction: column;
			box-sizing: border-box;
			opacity: 0.7;
		}

		.gw-contain {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			padding: 0 20px;
		}

		.uniform-card1 {
			/* border-right: 1px solid #d6d6d6; */
			height: 330px;
			display: flex;
			width: 100%;
			/* 30% 宽度 */
			margin: 10px;
			/* 左右各 10px 边距 */
			flex-direction: column;
			box-sizing: border-box;
			/* 确保宽度计算包含 padding 和 border */
			margin-top: 40px;
			margin-bottom: 20px;
		}

		.about-us-content {
			width: 100%;
			/* max-width: calc(30% * 3 + 20px * 2); */
			/* 3个卡片的宽度 + 2个margin */
			/* margin: 0 auto; */
			/* 居中对齐 */
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			background-color: #f6f6f6;
		}

		/* 图片样式 - 计算精确宽度 */
		.about-us-image {
			width: 100%;
			/* 3个卡片宽度 + 2个间距 */
			height: auto;
			object-fit: cover;
			box-sizing: border-box;
		}

		.grid-content {
			background-color: #fafafa;
			padding: 20px;
			display: flex;
			flex-direction: column;
			width: 100%;
			box-sizing: border-box;
			align-items: center;
		}

		.video-contain video {
			width: 90%;
		}
	}
</style>